/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import pathify, {
  make
} from 'vuex-pathify'
import VuexPersist from 'vuex-persist';

const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: "vuex",
  storage: window.localStorage, // or window.sessionStorage or localForage
  reducer: (state) => ({
    selectedSchoolRef: state.selectedSchoolRef,
  }),
});

const state = {
  // greeting: 'Hello',
  // name: 'World',
  // scores: [{ group: 'A', score: 11 }, { group: 'B', score: 22 }],
  // score: 22,
  // department: null,
  // departmentRef: null,
  // count: 88,
  // role: null,
  xRouterLink: null,
  userData: null,
  userRefPath: null,
  logged: null,
  loggedEmail: null,
  currentUser: null,
  lessonCategoriesPath: "lessonCategories",
  selectedSchoolRef: null,
  availableSchools: null,
  selectedClassGroupTab: 0,
}

const mutations = make.mutations(state)
const actions = {
  logout({
    state,
    actions
  }) {
    state.userData.ref.update({
      lastLoggedOutAt: new Date()
    }).then(() => {
      fb.db.collection("logs").doc(state.userData.id).update({
        loggedOutAt: new Date(),
        logged: false
      }).then(() => {
        actions.clearData()
      })
    })

  },
  clearData({
    commit
  }) {
    // commit('setCurrentUser', null)
    commit('setSelectedSchoolRef', null)
    commit('setUserData', null)
  },
}
// const vuexLocalStorage = new VuexPersist({
//   key: 'vuex',  
//   storage: window.localStorage,  
// })

export const store = new Vuex.Store({
  plugins: [pathify.plugin, vuexLocalStorage.plugin],
  state,
  mutations,
  actions
})